
export default {
    downLoad(url) {
        var downloadElement = document.createElement('a');
        downloadElement.style.display = "none";
        downloadElement.href = url;
        downloadElement.target = '_blank'
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
    },
    isExcel(file) {
        let isExcel =
            file.type === "application/vnd.ms-excel" ||
            file.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        return isExcel;
    },
    getDate() {
        let dt = new Date();
        let yy = dt.getFullYear();
        let mm = dt.getMonth() + 1;
        if (mm < 10)
            mm = '0' + mm;
        let dd = dt.getDate();
        if (dd < 10)
            dd = '0' + dd;
        return yy + "-" + mm + "-" + dd;
    }
}